import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_pack_verification_instructions_grid_ComponentContextService } from './FootprintManager.pack_verification_instructions_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_pack_verification_instructions_gridComponentEntity {
  EntityType?: string, EntityName?: string, EntityId?: number, Instruction?: string, EntityCode?: string, Id?: number}

interface IFootprintManager_pack_verification_instructions_gridComponentInParams {
  shippingContainerId: number, startVerificationTaskId: number, isReadOnly: boolean}


class FootprintManager_pack_verification_instructions_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_pack_verification_instructions_gridComponent;
  entity: IFootprintManager_pack_verification_instructions_gridComponentEntity;

  vars: { isLoaded?: boolean } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    entity: null,
    instruction: null,
    URL: null,
  }



  constructor(
    grid: FootprintManager_pack_verification_instructions_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_pack_verification_instructions_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.entity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.entity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.instruction = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.instruction,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.URL = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.URL,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_pack_verification_instructions_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.EntityType,this.entity.EntityName,this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_pack_verification_instructions_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.EntityType,this.entity.EntityName,this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'EntityType',this.entity.EntityType);
    set($resultKey, 'EntityName',this.entity.EntityName);
    set($resultKey, 'Id',this.entity.Id);
    const inParams = {
      $keys:[$resultKey],
      shippingContainerId:  $grid.inParams.shippingContainerId ,
      excludeIds:  null ,
    };
    const data = await this.$datasources.PackVerification.ds_get_shippingcontainer_instructions.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_pack_verification_instructions_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.entity.displayControl as TextModel).text = `${$row.entity.EntityName} ${$row.entity.EntityCode}`;
    (this.cells.instruction.displayControl as TextModel).text = $row.entity.Instruction;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'URL' : {
        this.on_url_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_pack_verification_instructions_gridComponentRowModel,
  $grid: FootprintManager_pack_verification_instructions_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_pack_verification_instructions_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if( $row.entity.Instruction.indexOf('[{<') > 0)
  {
      $row.cells.instruction.displayControl.text = $row.entity.Instruction.split('[{<')[0]
      $row.cells.URL.displayControl.text = $row.entity.Instruction.split('[{<')[1].split('>}]')[0]
  }
  else 
  {
      $row.cells.URL.displayControl.text = ''
  }
  
  }
  on_url_clicked(event = null) {
    return this.on_url_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_url_clickedInternal(
    $row: FootprintManager_pack_verification_instructions_gridComponentRowModel,
  $grid: FootprintManager_pack_verification_instructions_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_pack_verification_instructions_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.cells.URL.displayControl.text)) {
  
      const newTab = window.open($row.cells.URL.displayControl.text, '_blank');   
      // Focus on the new tab 
      if (newTab) { newTab.focus(); }
  }
  $grid.refresh()
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-pack_verification_instructions_grid',
  templateUrl: './FootprintManager.pack_verification_instructions_grid.component.html'
})
export class FootprintManager_pack_verification_instructions_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_pack_verification_instructions_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);


  inParams: IFootprintManager_pack_verification_instructions_gridComponentInParams = { shippingContainerId: null, startVerificationTaskId: null, isReadOnly: null };


  //#region Variables
  vars: { shippingContainerCode?: string, instructions?: { entity?: string, code?: string, instruction?: string, isCompleted?: boolean, id?: number }[], isReadOnly?: boolean } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     entity: new GridHeaderModel(new HeaderStyles(null, null), 'entity', 'Entity', false, false, null, false),       instruction: new GridHeaderModel(new HeaderStyles(null, null), 'instruction', 'Instruction', false, false, null, false),       URL: new GridHeaderModel(new HeaderStyles(null, null), 'URL', 'URL', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_pack_verification_instructions_gridComponentRowModel[] = [];

  @Input('shippingContainerId') set $inParams_shippingContainerId(value: any) {
    this.inParams['shippingContainerId'] = value;
  }
  get $inParams_shippingContainerId(): any {
    return this.inParams['shippingContainerId'] ;
  }
  @Input('startVerificationTaskId') set $inParams_startVerificationTaskId(value: any) {
    this.inParams['startVerificationTaskId'] = value;
  }
  get $inParams_startVerificationTaskId(): any {
    return this.inParams['startVerificationTaskId'] ;
  }
  @Input('isReadOnly') set $inParams_isReadOnly(value: any) {
    this.inParams['isReadOnly'] = value;
  }
  get $inParams_isReadOnly(): any {
    return this.inParams['isReadOnly'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_pack_verification_instructions_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Instructions';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.shippingContainerId)) {
        this.$missingRequiredInParams.push('shippingContainerId');
      }
      if(isNil(this.inParams.startVerificationTaskId)) {
        this.$missingRequiredInParams.push('startVerificationTaskId');
      }
      if(isNil(this.inParams.isReadOnly)) {
        this.$missingRequiredInParams.push('isReadOnly');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 20;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      shippingContainerId:  $grid.inParams.shippingContainerId ,
      excludeIds:  null ,
    };
    try {
      const data = await this.$datasources.PackVerification.ds_get_shippingcontainer_instructions.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_pack_verification_instructions_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_pack_verification_instructions_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_pack_verification_instructions_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_pack_verification_instructions_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_pack_verification_instructions_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (!$grid.vars.isReadOnly) {
      for (let row of $grid.rows) {
          let instruction = $grid.vars.instructions.find(i => i.id === row.entity.Id);
          if (!$utils.isDefined(instruction)) {
              instruction = { entity: row.entity.EntityName, code: row.entity.EntityCode, instruction: row.entity.Instruction, isCompleted: row.selected, id: row.entity.Id };
              $grid.vars.instructions.push(instruction);
          }
  
          if (row.selected) {
              for (let key in $grid.headers) {
                  row.cells[key].styles.setStyle('background-color', 'rgba(0, 255, 0, 0.2)');
              }
              
              instruction.isCompleted = true;
          }
          else {
              for (let key in $grid.headers) {
                  row.cells[key].styles.resetStyle();
              }
  
              instruction.isCompleted = false;
          }
      }
  
      document.getElementsByTagName('FootprintManager-pack_verification_wizard')[0].dispatchEvent(new CustomEvent("handle_container_instructions_changed", { 'detail': $grid.vars.instructions }));
  }
  else {
      for (let row of $grid.rows) {
          let instruction = $grid.vars.instructions.find(i => i.id === row.entity.Id);
  
          if (instruction?.isCompleted && !row.selected) {
              row.selected = true;
          }
          else if (!instruction?.isCompleted && row.selected) {
              row.selected = false;
          }
      }
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_pack_verification_instructions_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_pack_verification_instructions_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.vars.instructions = [];
  
  let result = (await $datasources.PackVerification.ds_get_shippingcontainer_by_shippingContainerId.get({ shippingContainerId: $grid.inParams.shippingContainerId })).result;
  $grid.vars.shippingContainerCode = result.LookupCode;
  
  }
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_pack_verification_instructions_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_pack_verification_instructions_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.vars.isReadOnly = $grid.inParams.isReadOnly;
  
  // Get parent entities for eligible instructions
  await get_carrier_for_carrier_services();
  
  $grid.on_row_selected();
  
  /**************************************************
   * FUNCTIONS
  ***************************************************/
  async function get_carrier_for_carrier_services() {
      let target_rows = $grid.rows.filter(row => row.entity.EntityName.trim().toUpperCase() === 'CARRIERSERVICE');
  
      if (target_rows.length === 0) { return; }
  
      const container = (await $datasources.PackVerification.ds_get_shippingcontainer_by_shippingContainerId.get({ shippingContainerId: $grid.inParams.shippingContainerId})).result;
  
      for (let row of target_rows) {
          row.cells.entity.displayControl.text = `Carrier ${container.Shipment?.Carrier?.Name}, Service ${row.entity.EntityCode}`;
      }
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
